import React from 'react';
import { Colors } from '../../constants/colors';

export const ArrowLeftIcon = ({ color = Colors.white, size = 50 }: { color?: string, size?: number }) => (
  <svg width={size} height={size} viewBox="0 0 49 50" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M18.6907 37.2449L30.9407 24.8724L18.6907 12.5" stroke={color} strokeWidth="3" strokeLinecap="round"
          strokeLinejoin="round" />
  </svg>
);
